export default class errorsClass {
  constructor() {
    this.errorTxt = "";
    this.errorNum = 0;
  }

  get hasError() {
    return this.errorNum > 0;
  }
}
